import moment from "moment";
export class StaffAcademic {
  StaffID;
  AcademicCode;
  InstitueName;
  DateFrom;
  DateTo;
  AcademicDoc;
  AddBy;
  ModifyBy;
  Seq;
  tempCode;
  IsEditMode;
  AcademicDes;
  AcademicURL;
  AcademicFile;
  DocMime;
  IsImageFile;
  IsFromMenuActive;
  IsToMenuActive;
  constructor() {
    this.StaffID = "";
    this.AcademicCode = "";
    this.InstitueName = "";
    this.DateFrom = moment().format("YYYY-MM-DD");
    this.DateTo = moment().format("YYYY-MM-DD");
    this.AcademicDoc = "";
    this.AddBy = "";
    this.ModifyBy = "";
    this.IsEditMode = false;
    this.Seq = "";
    this.tempCode = "";
    this.AcademicDes = "";
    this.AcademicURL = "";
    this.AcademicFile = "";
    this.DocMime = "";
    this.IsImageFile = false;
    this.IsFromMenuActive = false;
    this.IsToMenuActive = false;
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffAcademic.js